import $ from 'jquery';

let $carousel = $('.Slider .carousel-inner');
let $items = $carousel.children('.item');
$items.slice(1).hide();

let itemsCount = $items.length;
let idCurr = -1;
let idNext;

!function loop() {
    idCurr = (idCurr + 1) % itemsCount;
    idNext = (idCurr + 1) % itemsCount;

    $items.eq(idCurr).delay(4000).fadeOut(2000);
    $items.eq(idNext).delay(4500).fadeIn(2000, loop);
}();

if(!document.querySelector("#Home > .IntroHeader > .csc-element")) {
    $("#Slider").addClass('first');
}
